import { BodyFlow, TertiaryButton } from '@monthio/react-components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import type { DeleteReason } from './debtItem'

import { Column } from './column'

const DeleteModalContainer = styled.div`
	padding: 8px 24px 24px 24px;
`

export const DeleteModal: React.FC<{
	close: (reason: DeleteReason) => void
}> = ({ close }) => {
	const { t } = useTranslation()
	return (
		<DeleteModalContainer>
			<BodyFlow>{t('debtOverview-deleteModal-sub-title')}</BodyFlow>
			<Column>
				<TertiaryButton onClick={() => close('paid')}>
					{t('debtOverview-deleteModal-option-paid')}
				</TertiaryButton>
				<TertiaryButton onClick={() => close('otherOwner')}>
					{t('debtOverview-deleteModal-option-other-owner')}
				</TertiaryButton>
				<TertiaryButton onClick={() => close('unrecognized')}>
					{t('debtOverview-deleteModal-option-unrecognized')}
				</TertiaryButton>
			</Column>
		</DeleteModalContainer>
	)
}
